import {
    InfoIcon
} from 'lucide-react';
import KBTooltipWrapper from './TooltipWrapper';

export default function LabelWithTooltip({
    tooltipText, label
}) {
    const ICON_SIZE = 15;
    return (
        <>
            <div className="flex justify-between items-center text-black">
                <label className="block text-[0.85rem] font-semibold mb-1">{label}</label>
                {tooltipText && <KBTooltipWrapper tooltipText={tooltipText}>
                    <InfoIcon className="ml-2" size={ICON_SIZE}/>
                </KBTooltipWrapper>}
            </div>
        </>
    );
}